import { useState } from 'react'
import { Input, Form, Radio, Switch } from 'antd'
import Cron from 'react-js-cron'
import EditableInput from 'Components/Weaver/Input/EditableInput'
import moment from 'moment'

const RunTypeFormItem = ({ name, disabled }) => {
  const runTypeOptions = [
    { label: 'Run Once', value: true },
    { label: 'Recurring', value: false }
  ]

  return (
    <Form.Item
      label="Run Type"
      name={name}
      rules={[
        {
          required: true,
          message: 'Select a schedule type',
        }
      ]}
    >
      <Radio.Group
        data-testid="run-type-selector"
        options={runTypeOptions}
        disabled={disabled}
        onChange={(e) => e.stopPropagation()}
      />
    </Form.Item>
  )
}

export const CronFormItem = ({ field, form, disabled }) => {
  const runTypeVal = Form.useWatch(["crons", field.name, "runOnce"], form)

  const handleSetCronValue = (val) => {
    let values = form.getFieldValue("crons")
    values[field.name].cron = {
      value: val,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
    form.setFieldsValue({ crons: values })
  }

  return (
    <div data-testid={`cron-form-item-${field.name}`}>
      <Form.Item
        noStyle
        name={[field.name, 'uid']}
      />
      <RunTypeFormItem name={[field.name, 'runOnce']} disabled={disabled}/>

      {runTypeVal === true &&
        <FirstRunFormItem name={[field.name, 'firstRun']} disabled={disabled}/>
      }
      {runTypeVal === false &&
        <CronSelectorFormItem
          disabled={disabled}
          name={[field.name, 'cron', 'value']}
          handleSetCronValue={handleSetCronValue}
        />
      }
    </div>
  )

}

const FirstRunFormItem = ({ name }) => {
  const disabledDate = (current) => (current && current < moment().startOf('day'))

  return (
    <Form.Item
      label="First run"
      name={name}
    >
      <EditableInput
        data-testid="task-first-run-selector"
        type="date"
        disabledDate={disabledDate}
      />
    </Form.Item>
  )
}

const CronSelectorFormItem = ({ name, handleSetCronValue, disabled }) => {

  const [isSimplified, setIsSimplified] = useState(true)

  return (
    <>
      <Form.Item
        valuePropName="checked"
        label="Simplified or Cron"
      >
        <Switch
          disabled={disabled}
          checkedChildren="Simplified"
          unCheckedChildren="Cron"
          checked={isSimplified}
          onChange={setIsSimplified}
        />
      </Form.Item>
      <Form.Item
        label="Schedule"
        name={name}
      >
        {
          isSimplified
          ?
          <Cron
            disabled={disabled}
            clearButton={false}
            setValue={handleSetCronValue}
          />
          :
          <Input disabled={disabled}/>
        }
      </Form.Item>
    </>
  )
}
